import { FieldPath, UseFormReturn } from 'react-hook-form';
import { Select, SelectProps } from '@chakra-ui/react';

type SelectInputProps<TFieldValues> = SelectProps & {
  name: FieldPath<TFieldValues>;
  list: { id: number | string | undefined; name: string }[];
  register: UseFormReturn<TFieldValues>['register'];
};

export const SelectTextInput = <TFieldValues,>({
  name,
  list,
  register,
}: SelectInputProps<TFieldValues>) => (
  <Select
    {...register(name, {
      required: '必須項目です。',
    })}
  >
    {list.map((component) => (
      <option key={component.id} value={component.id}>
        {component.name}
      </option>
    ))}
  </Select>
);
